import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const NewsletterIdeas = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 32 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          d="M5.94157 17.9729L7.43144 13.9483C7.76552 13.0459 8.62609 12.4468 9.58838 12.4468H22.1166C22.9995 12.4468 23.8044 12.9522 24.1881 13.7473L26.097 17.7032C26.4622 18.4601 26.3856 19.3558 25.8972 20.0397L24.987 21.3139C24.7094 21.7025 24.3177 21.9951 23.8664 22.151L14.8048 25.2814C14.3656 25.4331 13.8907 25.4482 13.4428 25.3248L8.00338 23.826C7.15158 23.5912 6.50953 22.8893 6.35148 22.02L5.83562 19.1828C5.76189 18.7773 5.79848 18.3594 5.94157 17.9729Z"
          fill="#99E538"
          stroke="#2B2F38"
          strokeWidth="1.4"
        />
        <path
          d="M7.86348 5.17758C7.96797 4.61587 8.47326 4.2 9.08405 4.2H22.8957C23.5125 4.2 24.0218 4.62421 24.121 5.19348C25.2514 11.6804 24.7854 19.1524 24.4832 22.462C24.4264 23.083 23.9063 23.5617 23.2539 23.5707L8.36215 23.7745C7.67269 23.7839 7.11833 23.2658 7.0851 22.6029C6.90965 19.1029 6.70969 11.3802 7.86348 5.17758Z"
          fill="white"
          stroke="#2B2F38"
          strokeWidth="1.4"
        />
        <path
          d="M5.6335 19.2822C5.39685 18.1778 6.58411 17.3178 7.55967 17.8869L14.6395 22.0168C15.4802 22.5072 16.5198 22.5072 17.3605 22.0168L24.3575 17.9352C25.3413 17.3613 26.5351 18.2401 26.2794 19.35L24.4495 27.2919C24.3135 27.8819 23.7882 28.3 23.1827 28.3H8.61683C8.00383 28.3 7.47413 27.8718 7.34569 27.2724L5.6335 19.2822Z"
          fill="#99E538"
          stroke="#2B2F38"
          strokeWidth="1.4"
        />
        <path
          d="M18.8 13.7032C18.8 14.4831 18.5365 14.9644 18.0008 15.5093C17.287 16.2353 17.2952 17.1418 17.2994 17.6146C17.2997 17.6483 17.3 17.6798 17.3 17.7089C17.3 18.1139 17.1341 18.3574 16.9073 18.522C16.6539 18.7057 16.3026 18.8 15.9887 18.8C15.6754 18.8 15.3317 18.7061 15.0853 18.5248C14.8652 18.3629 14.7 18.1196 14.7 17.7089C14.7 17.4381 14.6839 17.0614 14.5975 16.6782C14.5127 16.3023 14.3454 15.8525 13.9929 15.503C13.7074 15.2198 13.5168 14.9651 13.3935 14.6971C13.2722 14.4333 13.2 14.1213 13.2 13.7032C13.2 11.8601 14.4126 10.7 16 10.7C17.5874 10.7 18.8 11.8601 18.8 13.7032Z"
          fill="#FFDB59"
          stroke="#2B2F38"
          strokeWidth="1.4"
        />
        <path d="M10 13H11.0898" stroke="#2B2F38" strokeWidth="1.4" strokeLinecap="round" />
        <path d="M16 8.07812L16 7" stroke="#2B2F38" strokeWidth="1.4" strokeLinecap="round" />
        <path d="M20.8984 13H22" stroke="#2B2F38" strokeWidth="1.4" strokeLinecap="round" />
        <path d="M19.7587 9.27642L20.5 8.53813" stroke="#2B2F38" strokeWidth="1.4" strokeLinecap="round" />
        <path d="M12.5117 9.49988L11.7734 8.67955" stroke="#2B2F38" strokeWidth="1.4" strokeLinecap="round" />
      </svg>
    )
  },
)

export default NewsletterIdeas
